import AboutSection from "../components/sections/AboutSection";
import Highlights from "../components/sections/Highlights";
import LandingSection from "../components/sections/LandingSection";
import Portfolio from "../components/sections/Portfolio";
import Page from "components/layout/Page";

const Homepage = ({ headerRef }) => {
  return (
    <Page headerRef={headerRef}>
      <LandingSection />
      <AboutSection />
      <Highlights />
      <Portfolio />
    </Page>
  )
}

export default Homepage;